module.exports = __webpack_public_path__ + "img/ico7.07ad7dda.png";